import { render } from "./pledge.vue?vue&type=template&id=6145e858&scoped=true"
import script from "./pledge.vue?vue&type=script&lang=js"
export * from "./pledge.vue?vue&type=script&lang=js"

import "./pledge.vue?vue&type=style&index=0&id=6145e858&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6145e858"]])

export default __exports__